// @ts-strict-ignore
import { useMedia } from './useMedia'

type breakpointsList = `Xxxs` | `Xxs` | `Xs` | `Sm` | `Md` | `Lg` | `Xl` | `Xxl` | `Xxxl`

type UseBreakpointsTypes = {
	isLessThanBreakpoint: (value: breakpointsList) => boolean
	isLargeThanBreakpoint: (value: breakpointsList) => boolean
}

const BREAKPOINT_CSS_VAR_MAP: Record<breakpointsList, string> = {
	Xxxs: '--screenXxxs',
	Xxs: '--screenXxs',
	Xs: '--screenXs',
	Sm: '--screen-sm',
	Md: '--screenMd',
	Lg: '--screenLg',
	Xl: '--screenXl',
	Xxl: '--screenXxl',
	Xxxl: '--screenXxxl'
}

const BREAKPOINT_FALLBACK_PX: Record<breakpointsList, string> = {
	Xxxs: '360px',
	Xxs: '375px',
	Xs: '480px',
	Sm: '576px',
	Md: '768px',
	Lg: '992px',
	Xl: '1200px',
	Xxl: '1400px',
	Xxxl: '1600px'
}

const getBreakpointValue = (value: breakpointsList): string => {
	if (typeof window === 'undefined') {
		return BREAKPOINT_FALLBACK_PX[value]
	}

	const cssVarName = BREAKPOINT_CSS_VAR_MAP[value]
	const raw = window.getComputedStyle(document.documentElement).getPropertyValue(cssVarName)
	const normalized = raw.trim()

	return normalized || BREAKPOINT_FALLBACK_PX[value]
}

/* A custom hook that returns a function that checks if the screen size is less than or larger than a breakpoint. */
export const useBreakpoints = (): UseBreakpointsTypes => {
	const { isLessThan, isLargerThan } = useMedia()

	const isLessThanBreakpoint = (value: breakpointsList): boolean => isLessThan(getBreakpointValue(value))
	const isLargeThanBreakpoint = (value: breakpointsList): boolean => isLargerThan(getBreakpointValue(value))

	return { isLessThanBreakpoint, isLargeThanBreakpoint }
}
